@if (prefix) {
    <span class="input-group-text">
        <ng-content select="[prefix]"></ng-content>
    </span>
}

<ng-content></ng-content>

@if (suffix) {
    <span class="input-group-text">
        <ng-content select="[suffix]"></ng-content>
    </span>
}
